module.exports = __webpack_public_path__ + "static/media/roble_hacienda.9f53165a.jpg";